import React from 'react';

import { SubtitleProps } from './models';
import styles from './styles.module.scss';

const Subtitle: React.FunctionComponent<SubtitleProps> = (props) => {
  const { title = '', dataTestId = 'subtitle' } = props;

  return (
    <>
      {title && <div className={styles.title} data-testid={dataTestId}>{title}</div>}
    </>
  );
};

export default Subtitle;
